
import { Component, Prop, Vue } from 'vue-property-decorator';

import ITask from '@/interfaces/ITask';

import { Button } from '@atoms';

import CheckboxBlankCircleOutline from 'vue-material-design-icons/CheckboxBlankCircleOutline.vue';
import CheckCircleOutline from 'vue-material-design-icons/CheckCircleOutline.vue';
import DeleteOutline from 'vue-material-design-icons/DeleteOutline.vue';
import { getModule } from 'vuex-module-decorators';
import HomeStore from '@/store/modules/home.module';

@Component({
  components: {
    Button,
    CheckboxBlankCircleOutline,
    CheckCircleOutline,
    DeleteOutline,
  },
})
export default class TaskItem extends Vue {
  @Prop() readonly task!: ITask;

  homeStore = getModule(HomeStore, this.$store);

  checkTask() {
    this.task.check = !this.task.check;
  }

  removeTask() {
    this.homeStore.removeTask(this.task.id);
  }
}
